import apiSauce from "./api-sauce";

export class DashboardApi {


}
